import React from 'react';
import PropTypes from 'prop-types';
import ScrollContainer from 'react-indiana-drag-scroll';

const PortletHeaderTabs = ({ tabs, onChangeTabs, title, wizardTemp, variant }) => {
  const handleChangeTabs = (tab) => () => {
    onChangeTabs(tab);
  };
  const variantClass = ['segmented', 'chrome'].includes(variant)
    ? `portlet__header-tabs--${variant}`
    : '';
  return (
    <ScrollContainer
      className={`portlet__header-tabs ${variantClass} ${title === 'Team' ? '_2-step' : ''} ${
        wizardTemp ? '_1-step' : ''
      }`}
      vertical={false}
      hideScrollbars
    >
      {tabs?.map((tab, i) => (
        <div
          key={tab.id || i}
          className={`mb-2 d-inline-flex align-items-center ${
            title === 'Notifications' && !wizardTemp ? `_1-step` : ''
          } ${title !== 'Team' && !wizardTemp ? `_${i + 2}-step` : ''} ${
            tab.tabsDisbaled ? 'feature-pending' : ''
          } portlet__header-tab ${tab.active ? 'tab-active' : ''} ${
            tab?.hide ? 'd-none' : ''
          }`}
          onClick={handleChangeTabs(tab.id)}
        >
          {tab.icon && (
            <span className="d-inline-flex align-items-center me-1">
              {tab.icon}
            </span>
          )}
          {tab.title}
        </div>
      ))}
    </ScrollContainer>
  );
};

PortletHeaderTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  onChangeTabs: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(['default', 'segmented', 'chrome']),
};

export default PortletHeaderTabs;
